export const EMPTY_MESSAGE = "Unknown Error";
export const EMPTY_STACK_TRACE = "";
export const DEFAULT_ERROR_NAME = "Error";

export const getErrorMessage = (error: unknown): string => {
  let message = EMPTY_MESSAGE;
  if (error === undefined || error === null) {
    message = EMPTY_MESSAGE;
  } else if (typeof error === "object" && "message" in error) {
    message = String((error as { message: unknown }).message);
  } else {
    message = String(error);
  }

  return message;
};

/**
 * Will extract the stack from the error, taking the first key found among:
 * `stacktrace`, `stack`, `componentStack` (component tree for component errors,
 * which contains only native components names in production).
 *
 * In last resort and if `sourceURL`, `line` and `column` are present, it will
 * generate a stack from this information.
 */
export const getErrorStackTrace = (error: unknown): string => {
  let stack = EMPTY_STACK_TRACE;

  try {
    if (error === undefined || error === null) {
      stack = EMPTY_STACK_TRACE;
    } else if (typeof error === "string") {
      stack = EMPTY_STACK_TRACE;
    } else if (typeof error === "object") {
      if ("stacktrace" in error) {
        stack = String((error as { stacktrace: unknown }).stacktrace);
      } else if ("stack" in error) {
        stack = String((error as { stack: unknown }).stack);
      } else if ("componentStack" in error) {
        stack = String((error as { componentStack: unknown }).componentStack);
      } else if (
        "sourceURL" in error &&
        "line" in error &&
        "column" in error &&
        (error as { sourceURL: unknown }).sourceURL &&
        (error as { line: unknown }).line &&
        (error as { column: unknown }).column
      ) {
        stack = `at ${(error as { sourceURL: string }).sourceURL}:${
          (error as { line: number }).line
        }:${(error as { column: number }).column}`;
      }
    }
  } catch (e) {
    // Do nothing
  }
  return stack;
};

export const getErrorName = (error: unknown): string => {
  try {
    if (typeof error !== "object" || error === null) {
      return DEFAULT_ERROR_NAME;
    }
    if (typeof (error as { name?: unknown }).name === "string") {
      return (error as { name: string }).name;
    }
  } catch (e) {
    // Do nothing
  }
  return DEFAULT_ERROR_NAME;
};
